import { z } from 'zod';

/** ISO 8601 datetime string on the wire. Offsets are accepted so autopilot timestamps pass. */
export const isoDateTimeSchema = z.iso.datetime({ offset: true });

export const DEFAULT_PAGE_LIMIT = 25;
export const MAX_PAGE_LIMIT = 100;

/**
 * Cursor pagination query. `limit` is coerced because it arrives as a query string.
 * Strict: unknown query keys are rejected.
 */
export const paginationQuerySchema = z.strictObject({
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(MAX_PAGE_LIMIT).default(DEFAULT_PAGE_LIMIT),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

/** Page response `{ items, nextCursor }`; `nextCursor` is null on the last page. */
export const pageSchema = <T extends z.ZodType>(item: T) =>
  z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });
export type Page<T> = { items: T[]; nextCursor: string | null };

/** The authenticated person behind an action. */
export const actorSchema = z.object({
  sub: z.string().min(1),
  email: z.string(),
  name: z.string().optional(),
});
export type Actor = z.infer<typeof actorSchema>;
